import 'twin.macro';
import 'styled-components/macro';
import { gql } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import { useCreateSweetMutation } from 'types/graphql-toy';

import SweetForm from '../../organisms/sweet-form/SweetForm';

const CreateSweet = () => {
  const [createSweet, { error, loading }] = useCreateSweetMutation();
  const { push } = useHistory();

  const createSweetAndRedirect = async (variables: { title: string; expiresAt: string }) => {
    await createSweet({
      variables,
    });

    push('/toy-shop/sweet');
  };

  return (
    <div>
      <h2 tw="display-2">Add new sweet</h2>
      <SweetForm onSubmit={createSweetAndRedirect} onCancel={() => push('/')} isLoading={loading} />
      {error && <p tw="text-error">{error.message}</p>}
    </div>
  );
};

gql`
  mutation createSweet($title: String!, $expiresAt: Time!) {
    createSweet(title: $title, expiresAt: $expiresAt) {
      id
      title
      created_at
      expires_at
    }
  }
`;

export default CreateSweet;
